import { Box, Stack, TableBody, TableCell, TableRow } from '@mui/material';
import axios from 'axios';
import { useEffect, useState } from 'react';
import { TableCustom } from '../../components/common';
import { AddButton } from '../../components/common/button/CustomButtons';
import ModalCustom from '../../components/common/Modal';
import ChildHeader from '../../components/ui/ChildHeader';
import { useQuery } from '../../hooks/UseQuery';
import { useAuth } from '../../services/auth/AuthProvider';
import ModalInput from './ModalInput';
import { listConstant, apiConstant, navigationConstant } from './constant';
import React from 'react';
import {
  EditIconButton,
  DeleteIconButton,
  ViewIconButton,
  CardIconButton,
} from '../../components/common/button/CustomIconButton';
import { useNavigate } from 'react-router-dom';

// User IDs for access control
const CREATE_ACCESS_USER_IDS = [
  '679ca6296d777c639759f554', // Suraj
  '6634ad002d0f294182dea256', // Rajesh
  '6630b1321433a777c3031e7b', // Admin (Lalit)
  '6630ae31feb7b21c70b60d7e', // Quality Manager
];

const getYearRange = (currentDate: any) => {
  if (!currentDate) return;
  const year = new Date(currentDate).getFullYear();
  return `${year} - ${year + 1}`;
};

const tableHeaderObj = [
  [
    { text: '#', rowspan: 1, colspan: 1 },
    { text: 'Title', rowspan: 1, colspan: 1 },
    { text: 'Date Range', rowspan: 1, colspan: 1 },
    { text: 'Action', rowspan: 1, colspan: 1 },
  ],
];

const TableList = () => {
  const { state } = useAuth();
  const { user } = state;
  const date = useQuery('date');
  const [tableData, setTableData] = useState<any[]>([{}]);
  const [listId, setListId] = useState('');
  const [render, setRender] = useState(false);
  const [isOpenPopup, setIsOpenPopup] = useState(false);
  const navigate = useNavigate();

  const currentUserId = state.user?._id?.toString();
  const canCreate = currentUserId && CREATE_ACCESS_USER_IDS.includes(currentUserId);

  useEffect(() => {
    axios
      .get(`/api/${apiConstant.gettableDataurl}/${date || 'all'}`)
      .then((res) => {
        if (res.data) setTableData(res.data);
      })
      .catch((err) => console.log(err));
  }, [render, date, isOpenPopup]);

  const handleDelete = async (id: string) => {
    let isDeleted = window.confirm(
      'Are you sure you want to delete this document?'
    );
    if (isDeleted) {
      axios
        .delete(`/api/${apiConstant.deleteurl}/${id}`)
        .then(() => {
          alert('document deleted successfully');
          setRender((prev) => !prev);
        })
        .catch((err) => {
          console.log(err);
        });
      return;
    }
  };

  return (
    <Box>
      <ChildHeader text={`${listConstant.childHeader}`}>
        {canCreate && (
          <AddButton
            label={`${listConstant.addButtonLable}`}
            onClick={() => setIsOpenPopup(true)}
          />
        )}
      </ChildHeader>
      <TableCustom tableHeaderObj={tableHeaderObj}>
        <TableBody>
          {tableData &&
            tableData.map((item: any, index: number) => (
              <React.Fragment key={item._id}>
                <TableRow>
                  <TableCell align="center">{index + 1}</TableCell>
                  <TableCell align="center">{item?.title}</TableCell>
                  <TableCell align="center">
                    {getYearRange(item.date_range)}
                  </TableCell>
                  <TableCell>
                    <Stack direction="row" sx={{ justifyContent: 'center' }} gap={1}>
                      <ViewIconButton
                        tooltipTitle="View Plan"
                        onClick={() => {
                          navigate(
                            `${navigationConstant.createPlanSchedule}/${item?._id
                            }?yearRange=${getYearRange(item?.date_range)}&isView=true`
                          );
                        }}
                      />
                      {canCreate && (
                        <EditIconButton
                          tooltipTitle="Edit Plan"
                          onClick={() => {
                            navigate(
                              `${navigationConstant.createPlanSchedule}/${item?._id
                              }?yearRange=${getYearRange(item?.date_range)}&isView=false`
                            );
                          }}
                        />
                      )}
                      {canCreate && (
                        <CardIconButton
                          tooltipTitle="Edit Header"
                          onClick={() => {
                            setListId(item?._id || '');
                            setIsOpenPopup(true);
                          }}
                        />
                      )}
                      {canCreate && (
                        <DeleteIconButton
                          tooltipTitle="DELETE"
                          onClick={() => {
                            handleDelete(item?._id || '');
                          }}
                        />
                      )}
                    </Stack>
                  </TableCell>
                </TableRow>
              </React.Fragment>
            ))}
        </TableBody>
      </TableCustom>
      <ModalCustom
        title={`${listConstant.modalTile}`}
        openModal={isOpenPopup}
        closeModal={() => {
          setIsOpenPopup(false);
          setListId('');
        }}
      >
        <ModalInput
          setIsModal={setIsOpenPopup}
          id={listId}
          setListId={setListId}
        />
      </ModalCustom>
    </Box>
  );
};

export default TableList;
